(function() {
    'use strict';

    angular
        .module('app.shared')
        .component('sc3NoScoreReason', {
            templateUrl: 'app/shared/score-posting/no-score-reason.component.html',
            controller: NoScoreReasonComponent,
            bindings: {
                teeTime: '<',
                onPosted: '&'
            }
        });

    var noop = angular.noop;

    NoScoreReasonComponent.$inject = ['alert', 'Score', 'reasonForNotPostingType', 'shared_resources'];
    function NoScoreReasonComponent(alert, Score, reasonForNotPostingType, resources) {
        var ctrl = this;
        ctrl.form = null;
        ctrl.submit = submit;
        ctrl.reasonList = Object.keys(reasonForNotPostingType.$metadata);

        function submit() {
            if (ctrl.form.$valid) {
                Score.updateTeeTime(ctrl.teeTime, true).$promise
                    .then(setPristine)
                    .then(fireEvent)
                    .catch(showError);
            }

            function setPristine(newTeeTime) {
                ctrl.teeTime = newTeeTime;
                ctrl.form.$setPristine();
            }

            function fireEvent() {
                ctrl.onPosted(null);
            }

            function showError(response) {
                alert.error(resources.postNoScoreError);
            }
        }
    }
})();